import type { ValueEvent } from '@adornis/base/utilTypes.js';
import type { RegistrationUserDataPlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import type { User } from '@adornis/buchungsheld-db/entities/user.js';
import type { BHTranslationDictionary } from '@adornis/buchungsheld-db/translations/translation.js';
import { css } from '@adornis/chemistry/directives/css.js';
import type { GenericFieldFormController } from '@adornis/cms/client/generic-field-formcontroller.js';
import '@adornis/internationalization/client/x-tel-input.js';
import type { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { html, nothing } from 'lit';
import { SDSalutationEnum, type SDStammdaten } from '../stammdaten/sd-stammdaten-plugin.js';
import type { SDTutorStammdaten } from '../stammdaten/sd-tutor-stammdaten-plugin.js';

export const sdTutorRegistrationUserDataPlugin: RegistrationUserDataPlugin<SDStammdaten> = {
  id: 'registration::user-data::sd-tutor',
  type: 'registration::user-data',
  render: (
    _stammdatenController: GenericFieldFormController<SDStammdaten>,
    translationController: TranslationController<BHTranslationDictionary>,
    user: User,
  ) => {
    const stammdatenController = _stammdatenController as any as GenericFieldFormController<SDTutorStammdaten>;
    const genericFieldOption = (fieldName: string) =>
      ({
        placeholder: translationController.translate('sd', 'field', fieldName as any) as string,
        placeholderMode: 'static-floating',
      } as const);

    return html`
      <x-flex space="sm">
        <x-flex horizontal space="sm">
          <x-dropdown-selection
            ${css({ flexGrow: '1' })}
            .selectables=${['Herr', 'Frau', 'Sonstiges']}
            .value=${(() => {
              const value = stammdatenController.document?.salutation;
              if (value === 'Herr') return 'Herr';
              if (value === 'Frau') return 'Frau';
              return 'Sonstiges';
            })()}
            @value-picked=${(e: ValueEvent<SDSalutationEnum>) => {
              const value = e.detail.value;
              if (value === SDSalutationEnum.SDHERR) stammdatenController.document!.salutation = value;
              else if (value === SDSalutationEnum.SDFRAU) stammdatenController.document!.salutation = value;
              else stammdatenController.document!.salutation = '';
            }}
            placeholder=${translationController.translate('sd', 'field', 'salutation')}
            .renderString=${salutation => {
              return salutation;
            }}
          ></x-dropdown-selection>
          ${(() => {
            if (stammdatenController.document!.salutation === 'Herr') return nothing;
            if (stammdatenController.document!.salutation === 'Frau') return nothing;
            return stammdatenController.genericField(['salutation'], genericFieldOption('salutation'));
          })()}
        </x-flex>

        <!-- use date instead of datetime -->
        <x-date-picker-dropdown
          ${stammdatenController.field('birthday')}
          placeholder=${translationController.translate('sd', 'field', 'birthday')}
          ?show-time=${false}
        ></x-date-picker-dropdown>

        ${stammdatenController.genericField(['department'], genericFieldOption('department'))}
        ${stammdatenController.genericField(['tutoriumsTitle'], genericFieldOption('tutoriumsTitle'))}
        ${stammdatenController.genericField(['unterstuetzungsBedarf'], genericFieldOption('unterstuetzungsBedarf'))}
      </x-flex>
    `;
  },
};
